module.exports = __webpack_public_path__ + "static/media/people-chat-square-fill.5c54e3e2.svg";